module.exports = __webpack_public_path__ + "img/SMT_13_Ms_Carol_Choi.72be6868.jpg";